import { render, staticRenderFns } from "./Blacklists.vue?vue&type=template&id=8ccc2484&"
import script from "./Blacklists.vue?vue&type=script&lang=js&"
export * from "./Blacklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports